const exceptionTypeName = 'EXCEPTION';

const fcmExceptionNotificationTypes = {
  1: 'SHIPMENT_NUMBER_CREATION_EXCEPTION',
  2: 'TRUCK_IN_EXCEPTION',
  3: 'TRUCK_OUT_EXCEPTION',
  4: 'MATERIAL_QUANTITY_EXCEPTION',
  5: 'MATERIAL_INVOICE_CREATION_EXCEPTION',
  6: 'REACH_AT_EXCEPTION',
  7: 'VEHICLE_ASSIGNMENT_EXCEPTION',
};

const fcmExceptionNotificaionValues = {
  SHIPMENT_NUMBER_CREATION_EXCEPTION: 'SHIPMENT_NUMBER_CREATION_EXCEPTION',
  TRUCK_IN_EXCEPTION: 'TRUCK_IN_EXCEPTION',
  TRUCK_OUT_EXCEPTION: 'TRUCK_OUT_EXCEPTION',
  MATERIAL_QUANTITY_EXCEPTION: 'MATERIAL_QUANTITY_EXCEPTION',
  MATERIAL_INVOICE_CREATION_EXCEPTION: 'MATERIAL_INVOICE_CREATION_EXCEPTION',
  REACH_AT_EXCEPTION: 'REACH_AT_EXCEPTION',
  VEHICLE_ASSIGNMENT_EXCEPTION: 'VEHICLE_ASSIGNMENT_EXCEPTION',
};

const fcmDeviationNotificationMessage = {
  SHIPMENT_NUMBER_CREATION_EXCEPTION: 'GGP was not created before the cut-off time',
  TRUCK_IN_EXCEPTION: 'Truck did not reach source before cut-off time',
  TRUCK_OUT_EXCEPTION: 'GGP out not done before cut-off time',
  MATERIAL_QUANTITY_EXCEPTION: 'ASN quantity mismatch against schedule',
  MATERIAL_INVOICE_CREATION_EXCEPTION: 'ASN not created before cut-off time',
  REACH_AT_EXCEPTION: 'Truck did not reach destination before the cut-off time',
  VEHICLE_ASSIGNMENT_EXCEPTION: 'Vehicle did not get assigned before the cut-off time',
};

const fcmDeviationNotificationTitle = {

    SHIPMENT_NUMBER_CREATION_EXCEPTION: 'SHIPMENT NUMBER CREATION EXCEPTION',
    TRUCK_IN_EXCEPTION: 'TRUCK IN EXCEPTION',
    TRUCK_OUT_EXCEPTION: 'TRUCK OUT EXCEPTION',
    MATERIAL_QUANTITY_EXCEPTION: 'MATERIAL QUANTITY EXCEPTION',
    MATERIAL_INVOICE_CREATION_EXCEPTION: 'MATERIAL INVOICE CREATION EXCEPTION',
    REACH_AT_EXCEPTION: 'REACH AT EXCEPTION',
      VEHICLE_ASSIGNMENT_EXCEPTION: 'VEHICLE ASSIGNMENT EXCEPTION',

};

module.exports = {
    exceptionTypeName,
    fcmExceptionNotificationTypes,
    fcmExceptionNotificaionValues,
    fcmDeviationNotificationMessage,
    fcmDeviationNotificationTitle,
};
